import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { bookingPayment } from "../data/siteData";
import { db } from "./firebase";

export async function createBooking(bookingDetails) {
  const booking = {
    ...normalizeBookingDetails(bookingDetails),
    payment: {
      provider: "paypal_me",
      amount: bookingPayment.amount,
      currency: bookingPayment.currency,
      status: "manual_check_required"
    },
    source: "landing_page",
    status: "payment_unverified",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  const bookingRef = await addDoc(collection(db, "bookings"), booking);

  return {
    id: bookingRef.id,
    ...booking,
    createdAt: null,
    updatedAt: null
  };
}

function normalizeBookingDetails(bookingDetails) {
  return {
    fullName: cleanText(bookingDetails.fullName),
    email: cleanText(bookingDetails.email).toLowerCase(),
    whatsappNumber: cleanText(bookingDetails.whatsappNumber),
    currentLevel: cleanText(bookingDetails.currentLevel),
    isBeginner: bookingDetails.isBeginner === "yes",
    suggestedCallTime: cleanText(bookingDetails.suggestedCallTime)
  };
}

function cleanText(value = "") {
  return String(value).trim();
}
